import layout from "./layout.json";
import home from "./home.json";

const fr = { layout, home };

export default fr;
